import { SpinnerWrapper } from '../formUtilities/useSpinner';

/**
 * FsButton — design-system button primitive (SPEC-BUTTON.md).
 *
 * REUSE ME: when you need a button in new UI, use FsButton instead of a raw
 * MUI <Button> or a one-off styled element. Chrome lives in
 * src/styles/button.scss (.fs-btn-*). Pairs with the FsDialog primitives.
 *
 * variant: green (primary CTA) | mint (secondary) | dark (solid on light) | outline (ghost)
 * size:    sm | md | lg
 * Hover shifts the background color (no box shadow).
 */
export const FsButton = ({
	variant = 'green',
	size = 'md',
	fullWidth = false,
	loading = false,
	disabled = false,
	startIcon = null,
	endIcon = null,
	type = 'button',
	id = '',
	dataTestID = '',
	className = '',
	onClick,
	children,
}) => {
	const isDisabled = disabled || loading;

	const classes = [
		'fs-btn',
		`fs-btn--${variant}`,
		`fs-btn--${size}`,
		fullWidth ? 'fs-btn--block' : '',
		loading ? 'fs-btn--loading' : '',
		className,
	]
		.filter(Boolean)
		.join(' ');

	return (
		<button
			type={type}
			id={id || undefined}
			data-testid={dataTestID || undefined}
			disabled={isDisabled}
			onClick={onClick}
			className={classes}>
			{loading ? (
				<SpinnerWrapper classList="!text-current" />
			) : (
				<>
					{startIcon}
					<span>{children}</span>
					{endIcon}
				</>
			)}
		</button>
	);
};
